module.exports = __webpack_public_path__ + "static/Grupo537-48ba2aafabac0721eec5b747ce2ee0f8.png";